export class ScrollToTrigger extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['trigger']
  }

  checkValidity () {
    super.checkValidity()

    if (!this.dataset.target) {
      this.throwError(`Missing data-target attribute`)
    }

    if (!this.target) {
      this.throwError(
        `Can't find target element with selector ${this.dataset.target}`,
      )
    }
  }

  setupListeners () {
    super.setupListeners()

    this.listeners.add(
      this.els.trigger.element,
      'click',
      this.handleClick.bind(this),
    )
  }

  handleClick () {
    this.target.scrollIntoView(true)
  }

  get target () {
    return window.BAO.Utils.getElement(this.dataset.target)
  }
}

if (!customElements.get('scroll-to-trigger')) {
  customElements.define('scroll-to-trigger', ScrollToTrigger)
}
